import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://dofhinjgthfscfteqzea.supabase.co'
const supabaseKey = 'sb_publishable_PhVi0LUQ7BnpYqjcRH8nag_nkFrJJUh'

export const supabase = createClient(supabaseUrl, supabaseKey)